import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PatrimonioRoutingModule } from './patrimonio-routing.module';
import { PatrimonioListarComponent } from './patrimonio-listar/patrimonio-listar.component';
import { PatrimonioInserirComponent } from './patrimonio-inserir/patrimonio-inserir.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { PatrimonioEditarComponent } from './patrimonio-editar/patrimonio-editar.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    PatrimonioListarComponent,
    PatrimonioInserirComponent,
    PatrimonioEditarComponent
  ],
  imports: [
    CommonModule,
    PatrimonioRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    MessagesModule,
    ConfirmDialogModule,
    InputTextareaModule,
    CalendarModule,
    InputNumberModule,
    DropdownModule,
    ProgressSpinnerModule
],
  providers: [ConfirmationService]
})
export class PatrimonioModule { }
